import React from 'react';

const GalleryIcon = () => (
    <div className='GalleryIcon DesktopIcon'>
        <img
            // src='/images/GalleryIcon.png'
            src='/images/Finalized/GalleryIcon.png'
            alt='Gallery'
            draggable={false}
            onDragStart={(e) => e.preventDefault()}
        />
        <span>Gallery</span>
    </div>
);

export default GalleryIcon;
